import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {
  // YY_len: sessionStorage.getItem('YY_len') ? sessionStorage.getItem('YY_len') : '',
  // YY_slen: sessionStorage.getItem('YY_slen') ? sessionStorage.getItem('YY_slen') : '',
  // YY_td: sessionStorage.getItem('YY_td') ? sessionStorage.getItem('YY_td') : '',
  YY_USER_ID: sessionStorage.getItem('YY_USER_ID') ? sessionStorage.getItem('YY_USER_ID') : '',
  transData: sessionStorage.getItem('transData') ? JSON.parse(sessionStorage.getItem('transData')) : '',
};

export default new Vuex.Store({
  state,
  mutations: {
    set(state, info) {
      if (info.YY_USER_ID) {
        sessionStorage.setItem('YY_USER_ID', info.YY_USER_ID);
        state.YY_USER_ID = info.YY_USER_ID;
      }
      if (info.transData) {
        sessionStorage.setItem('transData', JSON.stringify(info.transData));
        state.transData = info.transData;
      }
      // if (info.YY_len) {
      //   sessionStorage.setItem('YY_len', info.YY_len);
      //   state.YY_len = info.YY_len;
      // }
      // if (info.YY_slen) {
      //   sessionStorage.setItem('YY_slen', info.YY_slen);
      //   state.YY_slen = info.YY_slen;
      // }
      // if (info.YY_td) {
      //   sessionStorage.setItem('YY_td', info.YY_td);
      //   state.YY_td = info.YY_td;
      // }
    },
  },
});
